export class TTPageLoader {

    constructor() {
    }

    load(type) {
        console.info("Loading page " + type)
        switch (type) {
            // don´t make this dynamic -> otherwise webpack struggles...
            case "gamelist":
                return import('./../components/tt-page-gamelist/tt-page-gamelist.js');
            case "game":
                return import('./../components/tt-page-game/tt-page-game.js');
            case "league":
                return import('./../components/tt-page-league/tt-page-league.js');
            case "club":
                return import('./../components/tt-page-club/tt-page-club.js');
            case "community-login":
                return import('./../components/tt-page-community-login/tt-page-community-login.js');
            case "community-list":
                return import('./../components/tt-page-community-list/tt-page-community-list.js');
            case "community-reporter":
                return import('./../components/tt-page-community-reporter/tt-page-community-reporter.js');
            case "admin":
                return import('./../components/tt-page-admin/tt-page-admin.js');
            case "admin-games":
                return import('./../components/tt-page-admin-games/tt-page-admin-games.js');
            case "admin-leagues":
                return import('./../components/tt-page-admin-leagues/tt-page-admin-leagues.js');
        }
    }

}